import angular from 'angular';

(() => {
  class MedicationService {
    constructor(BaseService, ngDialog, localStorageService) {
      'ngInject';

      Object.assign(this, { ...BaseService,
        ngDialog,
        localStorageService
      });
    }

    formatMedication(medication) {
      const formatted = Object.assign({}, medication);

      for (const key in formatted) {
        if (key.indexOf('default_') > -1) {
          formatted[key.replace('default_', '')] = medication[key];
        }
      }

      const formattedData = {
        medication_id: formatted.medication_id,
        dispense_amount: formatted.dispense_amount,
        short_directions: formatted.short_directions,
        pharmacy_notes: formatted.pharmacy_notes,
        days_supply: formatted.days_supply,
        num_refills: formatted.num_refills,
        no_substitutions: formatted.no_substitutions,
        pharmacy_id: formatted.pharmacy.id // dosespot_prescription_id: formatted.dosespot_prescription_id

      }; // For the payload we need to make sure the ID > 0
      // ID < 0 could mean a fake (temporary) ID generated before saving (not yet created on DB)
      //
      // formattedData.id > 0 => it will UPDATE the prescription
      // formattedData.id null or not existing => it will CREATE the prescription

      if (formatted.id && formatted.id > 0) {
        formattedData.id = formatted.id;
      }

      return formattedData;
    }

    searchLemonaidMedications(category_code, name) {
      const queryString = this.Utils.serializeQuery({
        category_code,
        name
      });
      return this.$http.get(`${this.API_URL}/medications${queryString}`);
    }

    updateLemonaidMedication(id, updates) {
      const payload = {}; // we need to add a prefix of "default_" to these keys

      const prefixedKeys = ['dispense_amount', 'short_directions', 'pharmacy_notes', 'days_supply', 'num_refills', 'no_substitutions'];
      for (const key in updates) {
        if (prefixedKeys.indexOf(key) > -1) {
          payload[`default_${key}`] = updates[key];
        }
      }

      if (updates.dosespot_medication) {
        payload.dosespot_medication = updates.dosespot_medication;
      }

      return this.$http.put(`${this.API_URL}/medications/${id}`, payload);
    }

    createPimsMedication(payload) {
      return this.$http.post(`${this.API_URL}/admin/medications`, payload);
    }

    getOnlineChargeTypes(){
      return this.$http.get(`${this.API_URL}/orderlines/chargetypes`)
    }
    getPimsMed(med_id){
      return this.$http.get(`${this.API_URL}/admin/medications/${med_id}`)
    }

    updatePimsMedication(medication_id, payload) {
      return this.$http.put(`${this.API_URL}/admin/medications/${ medication_id}`, payload);
    }

    getPimsMedication(medication_id) {
      return this.$http.get(`${this.API_URL}/admin/medications/${medication_id}`)
        .then(({ data }) => {
          if (!data.shipment_option) {
            data.shipment_option = 'standard';
          }
          return data;
        });
    }

    removePrescription(order_id, order_line_medication_id) {
      return this.$http.delete(`${this.API_URL}/admin/orders/${order_id}/medications/${order_line_medication_id}`);
    }

    showCreatePimsMedPopup(visit) {
      this.openCreatePimsMedForm(visit, response => {
        if (response && response.success) {// Do something
        } else {// User closed the popup
          // Do nothing
        }
      });
    }

    openCreatePimsMedForm(visit, callback) {
      return this.ngDialog.open({
        template: 'app/components/create-medication-form/create-medication-form.html',
        // To not allow the user closes the modal without explicitely to have some action
        // showClose: false,
        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,
        controller: 'CreateMedicationFormController',
        controllerAs: '$ctrl',
        className: 'ngdialog-theme-default create-medication-form-modal',
        data: {
          visit
        },

        preCloseCallback(res) {
          if (typeof res === 'object') {
            return callback(res);
          }

          return callback(false);
        }

      });
    }

    /**
     * @param {string} query - medication search query
     * @returns {array} list of matching medications
     */
    searchDosespotMedications(query) {
      if (!query || !query.trim()) {
        throw new Error('Provide a search query.');
      }
      return this.$http.get(`${this.API_URL}/admin/dosespot/medications?name=${query}`);
    }
    /**
     * @param {string} name - full name of medication
     * @returns {array} array of prescription strengths
     */


    getDosespotMedicationStrengths(name) {
      const encodedName = encodeURIComponent(name);
      const url = `${this.API_URL}/admin/dosespot/medications/${encodedName}/strengths`;
      return this.$http.get(url);
    }
    /**
     * @param {string} name - full name of medication
     * @param {string} strength - selected strength of medication
     * @returns {object} dosespot medication record
     */


    getDosespotMedicationRecord(name, strength) {
      const encodedName = encodeURIComponent(name);
      const encodedStrength = encodeURIComponent(strength);
      const url = `${this.API_URL}/admin/dosespot/medications/${encodedName}/strengths/${encodedStrength}`;
      return this.$http.get(url);
    }

    getMessageTemplateOverrideList(am) {
      const url = `${this.API_URL}/admin/messagetemplates/${am}/overrides`;
      return this.$http.get(url);
    }

    getDispenseUnits() {
      const url = `${this.API_URL}/admin/medications/dispenseunits`;
      return this.$http.get(url);
    }

    getMedicationLabelStyle(serviceCode, defaultMedicationCode) {
      const pimsParameter = this.localStorageService.get('pimsParameters');
      const pimsVisitParameters = pimsParameter && pimsParameter.pimsVisitParameters;
      const prescribedMedicineLabelConfig = pimsVisitParameters && pimsVisitParameters.medication_label_style
      const serviceConfig = prescribedMedicineLabelConfig && prescribedMedicineLabelConfig[serviceCode];
      const medicationStyle = serviceConfig && serviceConfig[defaultMedicationCode];
      return medicationStyle || '';
    }
  }

  MedicationService.$inject = ["BaseService", "ngDialog", "localStorageService"];
  angular.module('pims').service('MedicationService', MedicationService);
})();
